/**
* 基础菜单 商品管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" ref="formInline" label-width="88px" :model="formInline" class="user-search">
      <el-col span="6">
        <el-form-item prop="accountId" label="用户UID">
          <el-input clearable v-model="formInline.accountId" placeholder="请输入用户UID"></el-input>
        </el-form-item>
      </el-col>

      <el-col span="6">
        <el-form-item prop="phone" label="手机号码">
          <el-input oninput="if(value.length > 11) value=value.slice(0, 11)" type="number" clearable
                    v-model="formInline.phone" placeholder="输入手机号码"></el-input>
        </el-form-item>
      </el-col>
      <el-col span="6">
        <el-form-item prop="nickName" label="昵称">
          <el-input clearable v-model="formInline.nickName" placeholder="请输入昵称"></el-input>
        </el-form-item>
      </el-col>

      <el-col span="6">
        <el-form-item prop="sex" label="性别">
          <el-select v-model="formInline.sex" placeholder="不限">
            <el-option label="不限" value=""></el-option>
            <el-option label="男" value="1"></el-option>
            <el-option label="女" value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col span="6">
        <el-form-item prop="maritalStatus" label="婚姻状况">
          <el-select v-model="formInline.maritalStatus" placeholder="不限">
            <el-option label="不限" value=""></el-option>
            <el-option label="未婚" value="1"></el-option>
            <el-option label="离异" value="2"></el-option>
            <el-option label="丧偶" value="3"></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <!-- <el-form-item label="年龄">
        <el-col :span="5">
          <el-input  clearable  v-model="formInline.beginAge" placeholder="不限"></el-input>
        </el-col>
        <el-col class="line" :span="2"> &nbsp;&nbsp;&nbsp; -</el-col>
        <el-col :span="5">
          <el-input  clearable  v-model="formInline.endAge" placeholder="不限"></el-input>
        </el-col>
      </el-form-item> -->
      <el-col span="6">
        <el-form-item prop="education" label="学历">
          <el-select v-model="formInline.education" placeholder="请选择">
            <el-option
              placeholder="不限"
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>


      <!-- <el-form-item prop="version" label="版本号">
            <el-input  clearable v-model="formInline.version" placeholder="输入版本号"></el-input>
          </el-form-item> -->

      <el-col span="6">
        <el-form-item prop="registerType" label="注册类型">
          <el-select v-model="formInline.registerType" placeholder="不限">
            <el-option label="不限" value=""></el-option>
            <el-option v-for="item in PlatformTypeOptions" :label="item.label" :value="item.value"
                       :key="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col span="6">
        <el-form-item prop="nickNameStatus" label="昵称审核">
          <el-select v-model="formInline.nickNameStatus" placeholder="不限">
            <el-option label="不限" value=""></el-option>
            <el-option label="待审核" value="1"></el-option>
            <el-option label="通过" value="2"></el-option>
            <el-option label="不通过" value="3"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col span="6">
        <el-form-item prop="status" label="账号状态">
          <el-select v-model="formInline.status" placeholder="不限">
            <el-option label="不限" value=""></el-option>
            <el-option label="正常" value="1"></el-option>
            <el-option label="注销中" value="2"></el-option>
            <el-option label="已注销" value="3"></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col span="6">
        <el-form-item prop="isJoinActivity" label="参加活动">
          <el-select v-model="formInline.isJoinActivity" placeholder="不限">
            <el-option label="不限" value=""></el-option>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col span="6">
        <el-form-item prop="blockStatus" label="系统拉黑">
          <el-select v-model="formInline.blockStatus" placeholder="不限">
            <el-option label="不限" value=""></el-option>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col span="6">
        <el-form-item prop="deviceBlockStatus" label="设备拉黑">
          <el-select v-model="formInline.deviceBlockStatus" placeholder="不限">
            <el-option label="不限" value=""></el-option>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col span="6">
        <el-form-item prop="isVip" label="vip类型:">
          <el-select v-model="formInline.isVip" placeholder="不限">
            <el-option label="不限" value=""></el-option>
            <el-option label="线下超级会员" value="1"></el-option>
            <el-option label="线上VIP" value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col span="6">
        <el-form-item prop="headIconStatus" label="头像审核">
          <el-select v-model="formInline.headIconStatus" placeholder="不限">
            <el-option label="不限" value=""></el-option>
            <el-option label="待审核" value="1"></el-option>
            <el-option label="通过" value="2"></el-option>
            <el-option label="不通过" value="3"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col span="6">
        <el-form-item prop="isTestAccount" label="是否测试号">
          <el-select v-model="formInline.isTestAccount" placeholder="不限">
            <el-option label="不限" value=""></el-option>
            <el-option label="是" value="1"></el-option>
            <el-option label="不是" value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <!-- <el-col span="6">  <el-form-item prop="isPullStrings" label="直营牵线">
        <el-select v-model="formInline.isPullStrings" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option label="是" value="1"></el-option>
          <el-option label="不是" value="0"></el-option>

        </el-select>
      </el-form-item></el-col> -->

      <el-col span="6">
        <el-form-item prop="monthlyIncome" label="月收入">
          <el-select v-model="formInline.monthlyIncome" placeholder="不限">
            <el-option label="不限" value=""></el-option>
            <el-option label="5千以下" value="1"></el-option>
            <el-option label="5千-1万" value="2"></el-option>
            <el-option label="1万-2万" value="3"></el-option>
            <el-option label="2万-3万" value="4"></el-option>
            <el-option label="3万-5万" value="5"></el-option>
            <el-option label="5万以上" value="6"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col span="6">
        <el-form-item prop="source" label="客户来源">
          <el-select clearable v-model="formInline.source" placeholder="不限">
            <el-option v-for="(item,index) in forlist" :key="index" :label=item.label :value=item.value></el-option>
          </el-select>
        </el-form-item>
      </el-col>


      <el-col span="6">
        <el-form-item prop="registerAddress" label="注册地区">
          <el-cascader
            placeholder="不限"
            v-model="formInline.registerAddress"
            :options="options123"
            @change="onChange"

            clearable></el-cascader>
        </el-form-item>
      </el-col>

      <el-col span="6">
        <el-form-item prop="registerIpAddress" label="注册ip地区">
          <el-cascader
            placeholder="不限"
            v-model="formInline.registerIpAddress"
            :options="options1234123"
            @change="onChanges"

            clearable></el-cascader>
        </el-form-item>
      </el-col>

      <el-col span="6">
        <el-form-item prop="beginAppearanceScore" label="颜值分数">
          <el-input style="width: 80px;" clearable v-model="formInline.beginAppearanceScore"
                    placeholder="不限"></el-input>
          -
          <el-form-item prop="endAppearanceScore" label="">
            <el-input style="width: 80px;" clearable v-model="formInline.endAppearanceScore"
                      placeholder="不限"></el-input>
          </el-form-item>
        </el-form-item>
      </el-col>
      <el-col span="6">
        <el-form-item prop="isSyncCrm" label="CRM否导入">
          <el-select v-model="formInline.isSyncCrm" placeholder="不限">
            <el-option label="不限" value=""></el-option>
            <el-option label="未导入" value="0"></el-option>
            <el-option label="已导入" value="1"></el-option>

          </el-select>
        </el-form-item>
      </el-col>
      <br>
      <el-col span="6">
        <el-form-item prop="isRepeatCrm" label="是否重复">
          <el-select v-model="formInline.isRepeatCrm" placeholder="不限">
            <el-option label="不限" value=""></el-option>
            <el-option label="未重复" value="0"></el-option>
            <el-option label="已重复" value="1"></el-option>

          </el-select>
        </el-form-item>
      </el-col>
      <el-col span="6">
        <el-form-item prop="beginHeight" label="身高">

          <el-input style="width: 90px;" clearable v-model="formInline.beginHeight" placeholder="不限"></el-input>
          -

          <el-form-item prop="endHeight" label="">
            <el-input style="width: 90px;" clearable v-model="formInline.endHeight" placeholder="不限"></el-input>
          </el-form-item>
        </el-form-item>
      </el-col>
      <el-col span="6">
        <el-form-item>
          <el-form-item prop="beginAge" label="年龄">
            <el-input style="width: 80px;" clearable v-model="formInline.beginAge" placeholder="不限"></el-input>
            -
            <el-form-item prop="endAge" label="">
              <el-input style="width: 80px;" clearable v-model="formInline.endAge" placeholder="不限"></el-input>
            </el-form-item>
          </el-form-item>
        </el-form-item>
      </el-col>
      <el-col span="6">
        <el-form-item prop="isJoinVipClub" label="精英会员">
          <el-select v-model="formInline.isJoinVipClub" placeholder="不限">
            <el-option label="不限" value=""></el-option>
            <el-option label="是" value="1"></el-option>
            <el-option label="不是" value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <!-- <el-col span="10"> <el-form-item prop="beginPullStringsApplyTime" label="牵线时间">
        <el-col span="11">
          <el-date-picker  value-format="yyyy-MM-dd HH:mm:ss"    type="datetime" placeholder="选择日期" v-model="formInline.beginPullStringsApplyTime" style="width: 100%;"></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">&nbsp;&nbsp;&nbsp;&nbsp;-</el-col>
        <el-col span="11">
          <el-form-item prop="endPullStringsApplyTime" label="">
            <el-date-picker   value-format="yyyy-MM-dd HH:mm:ss"     type="datetime" placeholder="选择日期" v-model="formInline.endPullStringsApplyTime" style="width: 100%;"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-form-item></el-col> -->

      <el-col span="10">
        <el-form-item prop="beginRegisterTime" label="注册时间">
          <el-col span="11">
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期"
                            v-model="formInline.beginRegisterTime" style="width: 83%;"></el-date-picker> &nbsp;&nbsp;&nbsp;-
          </el-col>
          <el-col span="11">
            <el-form-item prop="endRegisterTime" label="">
              <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" default-time="['23:59:59']" type="datetime"
                              placeholder="选择日期" v-model="formInline.endRegisterTime"
                              style="width: 87%;"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
      </el-col>
      <el-col span="10">
        <el-form-item prop="beginLastActiveTime" label="活跃时间">
          <el-col :span="11">
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期"
                            v-model="formInline.beginLastActiveTime" style="width: 83%;"></el-date-picker>&nbsp;&nbsp;&nbsp;-
          </el-col>
          <el-col :span="11">
            <el-form-item prop="endLastActiveTime" label="">
              <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" default-time="['23:59:59']" type="datetime"
                              placeholder="选择日期" v-model="formInline.endLastActiveTime"
                              style="width: 87%;"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
      </el-col>
      <div style=" float: right; margin-right: 0px; margin-bottom: 10px; ">
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="success" icon="el-icon-delete"
                   @click="resetForm('formInline')">重置
        </el-button>

      </div>
    </el-form>

    <!--列表-->
    <el-table id="educe-table" max-height="650" ref="multipleTable" stripe :data="listData" highlight-current-row
              v-loading="loading"

              @select-all="selectall" @select="select" border element-loading-text="拼命加载中"
              style="width: 100%; font-size:18px">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column align="center" style="font-size: 22px;" prop="id" label="UID" width="110">
        <template slot-scope="scope">
          <img style="width:50%;" v-if="scope.row.isVip==1"
               src="https://test-cos.ynhlminiapp.com/ae6990bf-1687-4fee-b1c4-f579d5caf927.png" alt=""><br>
          <span style="font-size: 29px; font-weight: 600;  color: #885DDF; ">{{ scope.row.id }}</span>
          <br><img v-if="scope.row.isJoinVipClub==1" style="width: 90px; height: 30px; margin-top: 10px;"
                   src="https://online-miniapp-1304146125.cos.ap-beijing.myqcloud.com/a3c71c1d-165d-4688-9db4-0f63541cab90.png"
                   alt="">
          <br><span v-if="scope.row.isMember==1"
                    style="width: 90px; height: 30px; margin-top: 10px; color: red; font-size: 12px">线上VIP</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="nickName" label="昵称" width="150">
        <template slot-scope="scope">
          <span style="font-size: 20px;">{{ scope.row.nickName }}</span><br>
          <span style="color: #3399FF; font-size: 20px;" v-if="scope.row.nickNameStatus==1">(待审核)</span>
          <span style="color: #34D0B4; font-size: 20px;" v-if="scope.row.nickNameStatus==2">(审核通过)</span>
          <span style="color: #CF1F1F; font-size: 20px;" v-if="scope.row.nickNameStatus==3">(审核不通过)</span>

        </template>
      </el-table-column>
      <el-table-column align="center" prop="headIcon" label="头像" width="180">
        <template slot-scope="scope">
          <el-image
            style="width: 100px; height: 100px; "
            :src="scope.row.headIcon"
            :preview-src-list="[scope.row.headIcon]"/>
          <br>
          <span style="color: #3399FF; font-size: 20px;" v-if="scope.row.headIconStatus==1">(待审核)</span>
          <span style="color: #34D0B4; font-size: 20px;" v-if="scope.row.headIconStatus==2">(审核通过)</span><br>
          <span style="color: #CF1F1F; font-size: 20px;" v-if="scope.row.headIconStatus==3">(审核不通过)</span>
          <span style="color: #34D0B4; font-size: 20px;"
                v-if="scope.row.headIconStatus==2">颜值分数:{{ scope.row.appearanceScore }}</span>
          <!-- <div>{{scope.row.editTime|timestampToTime}}</div> -->
        </template>
      </el-table-column>
      <el-table-column prop="headIcon" label="基本信息" width="190">
        <template slot-scope="scope">
          <span style="font-size: 18px;">年龄:{{ scope.row.age }}/  <span
            :style="scope.row.sex==1? 'color: #34D0B4':'color: deeppink'">{{ scope.row.sex == 1 ? "男" : "女" }}</span>  </span><br/>
          <div style="font-size: 18px;">学历: <span v-if="scope.row.education==7">博士后</span>
            <span v-if="scope.row.education==6">博士</span>
            <span v-if="scope.row.education==5">硕士</span>
            <span v-if="scope.row.education==4">本科</span>
            <span v-if="scope.row.education==3">大专</span>
            <span v-if="scope.row.education==2">中专</span>
            <span v-if="scope.row.education==1">中专以下</span></div>
          <span style="font-size: 18px;">身高:{{ scope.row.height }} {{ scope.row.height ? 'cm' : '' }}</span><br/>
          <span style="font-size: 18px;">月收入:{{ scope.row.monthlyIncomeDesc }}</span><br/>
          <div style="font-size: 18px;">婚姻状况:
            <span style="font-size: 18px;" v-if="scope.row.maritalStatus==1">未婚</span>
            <span style="font-size: 18px;" v-if="scope.row.maritalStatus==2">离异</span>
            <span style="font-size: 18px;" v-if="scope.row.maritalStatus==3">丧偶</span>
          </div>
          <br/>
        </template>
      </el-table-column>
      <el-table-column prop="sex" label="地址" width="250">
        <template slot-scope="scope">
          <span style="font-size: 18px;">注册地址:{{ scope.row.registerAddress }}</span><br>
          <span style="font-size: 18px;">注册ip地址:{{ scope.row.registerIpAddress }}</span><br>
          <span style="font-size: 18px;">登录ip地址:{{ scope.row.loginAddress }}</span><br>
        </template>
      </el-table-column>
      <el-table-column prop="isSyncCrm" label="CRM是否导入" width="80" align="center">
        <template slot-scope="scope">

          <div>{{ scope.row.isSyncCrm == 0 ? '未导入' : "已导入" }} <span style="font-size: 28px;">
            {{ scope.row.syncCrmNum > 0 ? scope.row.syncCrmNum : '' }}
          </span></div>
        </template>
      </el-table-column>
      <el-table-column prop="isRepeatCrm" label="是否重复" width="80" align="center">
        <template slot-scope="scope">

          <div>{{ scope.row.isRepeatCrm == 0 ? '未重复' : "已重复" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="nickName" label="手机号码" width="150">
        <template slot-scope="scope">
          <div>{{ scope.row.phone|mobileStr }}</div>
        </template>

      </el-table-column>


      <!-- <el-table-column  prop="nickName" label="直营牵线" width="60" align="center">
       <template slot-scope="scope">
         <div style="font-size: 18px;">{{
           scope.row.isPullStrings==0?'否':"是"
            }}</div>

       </template>

     </el-table-column>
     <el-table-column  prop="age" label="牵线申请" width="220">
       <template slot-scope="scope">
         <div style="font-size: 18px">次数:{{ scope.row.pullStringsNum }}</div><br>
         <div v-if=" scope.row.pullStringsApplyTime" style="font-size: 18px">时间:{{ scope.row.pullStringsApplyTime|timestampToTime}}</div>
         <div v-if="!scope.row.pullStringsApplyTime" style="font-size: 18px">时间:{{ scope.row.pullStringsApplyTime||''}}</div>
       </template>
     </el-table-column> -->

      <el-table-column align="center" prop="joinActivity" label="参加活动" width="100">
        <template slot-scope="scope">
          <div> {{ scope.row.isJoinActivity == 0 ? '否' : "是" }}{{ scope.row.joinActivity }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="status" label="账号状态" width="100">
        <template slot-scope="scope">
          <span style="color: #3399FF;" v-if="scope.row.status==1">正常</span>
          <span style="color: darkgoldenrod;" v-if="scope.row.status==2">注销中</span>
          <span style="color: red;" v-if="scope.row.status==3||scope.row.status==null">已注销</span>
        </template>
      </el-table-column>

      <el-table-column prop="status" label="系统拉黑" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.blockStatus == 0 ? '否' : '是' }}</span>
          <div v-if="scope.row.blockTimeMills" style="font-size: 16px">{{ scope.row.blockTimeMills|timestampToTime }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="设备拉黑" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.deviceBlockStatus == 0 ? '否' : '是' }}</span>
          <div v-if="scope.row.deviceBlockTimeMills"
               style="font-size: 16px">{{ scope.row.deviceBlockTimeMills|timestampToTime }}
          </div>

        </template>
      </el-table-column>

      <el-table-column prop="registerTypeDesc" label="注册类型" width="120">
      </el-table-column>
      <el-table-column prop="nickName" label="注册时间" width="180">
        <template slot-scope="scope">
          <div style="font-size: 16px">{{ scope.row.registerTime|timestampToTime }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="nickName" label="活跃时间" width="180">
        <template slot-scope="scope">
          <div style="font-size: 16px">{{ scope.row.lastActiveTimeMills|timestampToTime }}</div>

        </template>
      </el-table-column>
      <el-table-column align="center" prop="sourceDesc" fixed="right" label="客户来源" width="150">
      </el-table-column>

      <el-table-column prop="version" style="font-size: 14px" label="版本号" width="100"></el-table-column>
      <el-table-column fixed="right" align="center" prop="nickName" label="操作" width="120">

        <template slot-scope="scope">
          <el-dropdown trigger="click" @click="handleClickDropDown('design', scope.row.id)" split-button
                       @command="onCommand" type="primary">
            管理
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="beforeHandleCommand('b', scope.row.id)">基本信息</el-dropdown-item>
              <el-dropdown-item :command="beforeHandleCommand('c', scope.row.id)">退费</el-dropdown-item>
              <el-dropdown-item
                :command="beforeHandleCommand('a', scope.row)">{{
                  scope.row.blockStatus == 0 ? '系统拉黑' : '取消系统拉黑'
                }}
              </el-dropdown-item>
              <el-dropdown-item v-if="scope.row.deviceId"
                                :command="beforeHandleCommand('d', scope.row)">
                {{ scope.row.deviceBlockStatus == 0 ? '设备拉黑' : '取消设备拉黑' }}
              </el-dropdown-item>
              <el-dropdown-item :command="beforeHandleCommand('e', scope.row.id)">金币充值/扣款</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>

      <!-- <template slot-scope="scope">
        <el-button @click="Clickbutton(scope.row.id)" type="primary">编辑</el-button>
        <el-button v-if="scope.row.joinActivity!='否'&&scope.row.status!=3&&roleId.roleId==1||roleId.roleId==2||roleId.roleId==3" @click="Clickbuttons(scope.row.id)" type="warning">退款</el-button>
      </template>
    </el-table-column> -->
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" style="float: right; margin-right:0px; height: 50px; margin-top: 50px;"
                @size-change="handleSizeChange" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <div style="margin-top: 20px; position: fixed; bottom: 50px; left: 260px;"
         v-if="roleId.roleId==1||roleId.roleId==2">
      <el-button v-if="ifShowbar==1" @click="selectalls(listData)" type="primary">全选</el-button>
      <el-button v-if="ifShowbar==2" @click="selectallsif(listData)" type="primary">反选</el-button>
      <el-button @click="imporList(1)" type="success">导出数据</el-button>
      <el-button @click="imporList(2)" type="success">导入CRM</el-button>
      <!-- <el-button @click="deledUser" type="danger">删除</el-button> -->
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%">

      <span>确定导出用户数据？</span>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="dialogVisibles">确 定</el-button>
  </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="delleVisible"
      width="30%"
    >
      <span>确定要删除吗？一旦执行不可恢复！</span>
      <span slot="footer" class="dialog-footer">
    <el-button @click="delleVisible = false">取 消</el-button>
    <el-button type="primary" @click="deleLVisibles">确 定</el-button>
  </span>
    </el-dialog>
    <!-- 退款 -->
    <el-dialog :close-on-click-modal="false" center title="是否退费" @close="quxiaodialogFormVisible" width="60%"
               :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="">
          <el-radio-group v-model="form.resource" @change="onClkiher">
            <el-radio :label="1">活动</el-radio>
            <el-radio :label="2">精英Club会员</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="form.resource==1">
          <el-form-item label="活动主题" prop="orderId">
            <el-radio-group v-model="form.orderId">

              <el-radio v-for="item in getRefundList" @change="changIput(item)" :key="item.orderId"
                        :label="item.orderId">{{ item.activityId }}&nbsp;&nbsp; {{
                  item.title
                }}&nbsp;&nbsp;&nbsp;(¥{{ item.amount }})
                &nbsp;&nbsp;&nbsp;&nbsp;活动时间:{{ item.activityBeginTimeMills|timestampToTime }}
              </el-radio>

            </el-radio-group>
          </el-form-item>
          <el-form-item label="退款渠道:">
            <span>{{ getRefundform }}</span>
          </el-form-item>
          <el-form-item v-if="ifrefundAmount" label="活动退费" prop="refundAmount">
            <el-input style="width: 180px;" type="number" v-model="form.refundAmount" auto-complete="off"
                      placeholder="请输入实际退款金额"></el-input>
          </el-form-item>
          <el-form-item label="退款原因" prop="refundReason">
            <el-input
              type="textarea"
              style="width: 600px;"
              placeholder="请输入退款说明"
              v-model="form.refundReason"
              maxlength="2000"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </div>
        <div v-else>
          <el-form-item label="精英Club会员" prop="orderIds">
            <el-radio-group v-model="form.orderId">

              <el-radio v-for="item in CludList" @change="changIput(item)" :key="item.orderId"
                        :label="item.orderId">{{ item.activityId }}&nbsp;&nbsp; {{
                  item.title
                }}&nbsp;&nbsp;&nbsp;¥{{ item.amount }}元
              </el-radio>

            </el-radio-group>
          </el-form-item>
          <el-form-item label="退款渠道:">
            <span>{{ getRefundform }}</span>
          </el-form-item>
          <el-form-item v-if="ifrefundAmount" label="活动退费" prop="refundAmount">
            <el-input style="width: 180px;" type="number" v-model="form.refundAmount" auto-complete="off"
                      placeholder="请输入实际退款金额"></el-input>
          </el-form-item>
          <el-form-item label="退款原因" prop="refundReason">
            <el-input
              type="textarea"
              style="width: 600px;"
              placeholder="请输入退款说明"
              v-model="form.refundReason"
              maxlength="2000"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="quxiaodialogFormVisible">取 消</el-button>
        <el-button type="primary" @click="OnsubmitForm('form')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" center title="是否拉黑" @close="quxiaodialogFormVisible" width="60%"
               :visible.sync="FormVisible">
      <el-form :model="formLg" :rules="rules" ref="formLg">
        <div><span style="color: red;">*</span>设备拉黑原因:</div>


        <el-form-item label="" prop="blockStatus" v-if="typenum==2">
          <div style="color: red;">永久封号</div>
          <el-radio-group v-model="formLg.blockStatus" style="line-height: 40px;">
            <el-radio
              :label="1">尊敬的用户，非常抱歉，您的账号因发布色情骚扰类违规信息，永久封禁账号/设备，若有疑问，可向平台进行申诉
            </el-radio>
            <el-radio
              :label="2">尊敬的用户，非常抱歉，您的账号因发布恶意谩骂、侮辱类信息，永久封禁账号/设备，若有疑问，可向平台进行申诉
            </el-radio>
            <el-radio
              :label="3">尊敬的用户，非常抱歉，您的账号因恶意注册多个违规账号，永久封禁账号/设备，若有疑问，可向平台进行申诉
            </el-radio>
            <!-- <el-radio :label="4">尊敬的用户，非常抱歉，您的账号因发布色情骚扰类违规信息，永久封禁账号/设备，若有疑问，可向平台进行申诉</el-radio> -->
            <el-radio
              :label="5">尊敬的用户，非常抱歉，您的账号因发布广告宣传骚扰类违规信息，永久封禁账号/设备，若有疑问，可向平台进行申诉
            </el-radio>
            <el-radio
              :label="6">尊敬的用户，非常抱歉，您的账号因头像、资料信息虚假或冒用，永久封禁账号/设备，若有疑问，可向平台进行申诉
            </el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="" prop="blockStatus" v-else>
          <div style="color: red;">封号一周</div>
          <el-radio-group v-model="formLg.blockStatus" style="line-height: 40px;">
            <el-radio
              :label="1">尊敬的用户，非常抱歉，您的账号发布色情骚扰类违规信息，封禁账号一周，若有疑问，可向平台进行申诉
            </el-radio>
            <el-radio
              :label="2">尊敬的用户，非常抱歉，您的账号因发布恶意谩骂、侮辱类信息，违规信息，封禁账号一周，若有疑问，可向平台进行申诉
            </el-radio>
            <el-radio
              :label="3">尊敬的用户，非常抱歉，您的账号因恶意注册多个违规账号，封禁账号一周，若有疑问，可向平台进行申诉
            </el-radio>
            <br>
            <!-- <el-radio :label="4">尊敬的用户，非常抱歉，您的账号因发布色情骚扰类违规信息，封禁账号一周，若有疑问，可向平台进行申诉</el-radio> -->

            <div style="width: 100%;height: 20px; "></div>
            <el-radio
              :label="4">尊敬的用户，非常抱歉，您的账号因发布色情骚扰类违规信息，永久封禁登入账号。若有疑问，可向平台进行申诉
            </el-radio>
            <el-radio
              :label="5">尊敬的用户，非常抱歉，您的账号因发布广告宣传骚扰类违规信息，永久封禁登入账号，若有疑问，可向平台进行申诉
            </el-radio>
            <el-radio
              :label="6">尊敬的用户，非常抱歉，您的账号因头像、资料信息虚假或冒用，永久封禁登入账号，若有疑问，可向平台进行申诉
            </el-radio>

          </el-radio-group>
          <div style="color: red; position: absolute; top: 48%; left: 0;">永久封号</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="QQFormVisible">取 消</el-button>
        <el-button type="primary" @click="OnsubmitFormLg('formLg')">确 定</el-button>
      </div>
    </el-dialog>


    <el-dialog
      title=""
      :visible.sync="rechargeVisible"
      width="30%">
      <el-form ref="rechargeForm" :model="rechargeForm" :rules="rechargeRules" label-width="80px">
        <el-form-item label="金币余额" prop="balance">
          {{ rechargeForm.balance }}币
        </el-form-item>
        <el-form-item label="操作" prop="operate">
          <el-radio-group v-model="rechargeForm.operate">
            <el-radio :label="1">充值</el-radio>
            <el-radio :label="2">扣减</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="充值金额" prop="coins" :rules="[
          {required: true, message: '充值金额不能为空', trigger: 'blur'},
          {type: 'number', min: 1, message: '金额不能小于1', trigger: 'blur'},
          {type: 'number', max: rechargeForm.operate === 1 ? 10000 : rechargeForm.balance,
           message: rechargeForm.operate === 1 ? '金额不能大于10000' : '金额不能大于余额', trigger: 'blur'},
        ]">
          <el-input-number style="width: 180px;" type="number"
                           v-model="rechargeForm.coins" auto-complete="off"
                           placeholder="请输入充值金额"></el-input-number>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input style="width: 180px;" v-model="rechargeForm.remark" auto-complete="off"
                    placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="rechargeVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleRecharge">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getRefundList, platformAccount} from '../../api/userMG'
import Axios from 'axios'
import Vue from 'vue'
import {mobileStr} from "../../utils/util"
import {login} from "../../api"
import {PlatformTypeOptions} from "../../enums/userEnum";


import Pagination from '../../components/Pagination'
import {rechargeOperate, walletCoins} from "../../api/rechargeMG";

export default {
  data() {
    return {
      PlatformTypeOptions,
      dialogVisible: false,
      delleVisible: false,
      ssoServer: "",
      FormVisible: false,
      FormVisibleXler: false,
      dialogFormVisible: false,
      ifShons: '',
      ifpayType: '',
      options1234123: [],
      forlist: [],
      roleId: "",
      getamount: '',
      getRefundList: [],
      ifrefundAmount: false,
      ifShowbar: 1,
      getRefundform: '',
      options123: [],
      formLg: {
        blockStatus: '',
        deviceId: '',
        type: '',
        toAccountId: '',

      },
      form: {
        resource: 1,
        accountId: "",//用户id
        orderId: "",//订单id
        refundAmount: "",//退款金额
        refundReason: "",//退款原因
      },

      ids: "",
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      options: [{
        value: '',
        label: '不限'
      }, {
        value: 1,
        label: '中专以下'
      }, {
        value: 2,
        label: '中专'
      }, {
        value: 3,
        label: '大专'
      }, {
        value: 4,
        label: '本科'
      }, {
        value: 5,
        label: '硕士'
      }, {
        value: 6,
        label: '博士'
      }, {
        value: 7,
        label: '博士后'
      }],
      source: [{
        value: 1,
        label: '网站注册'

      }, {
        value: 2,
        label: '人工录入'

      }, {
        value: 3,
        label: '资源导入'

      }, {
        value: 4,
        label: '相亲活动'

      }, {
        value: 5,
        label: '手机来电'

      }, {
        value: 6,
        label: '表单填写'

      }, {
        value: 7,
        label: '到店咨询'

      }],
      typenum: '',
      editForm: {
        deptId: '',
        deptName: '',
        deptNo: '',
        token: localStorage.getItem('logintoken')
      },
      importList: [],
      // rules表单验证
      rules: {
        // orderIds: [
        //   { required: true, message: '精英Clud会员不能为空', trigger: 'blur' }
        // ],
        orderId: [
          {required: true, message: '活动主题不能为空', trigger: 'blur'}
        ],
        refundAmount: [
          {required: true, message: '活动退费金额不能为空', trigger: 'blur'}
        ],
        refundReason: [
          {required: true, message: '退款原因不能为空', trigger: 'blur'}
        ],
        deptName: [
          {required: true, message: '请输入部门名称', trigger: 'blur'}
        ],
        deptNo: [{required: true, message: '请输入部门代码', trigger: 'blur'}]
      },
      adder: "",
      CludList: [],
      onaccountId: '',
      userifom: "",
      formInline: {
        isSyncCrm: '',
        isJoinVipClub: "",
        status: "",
        deviceBlockStatus: "",
        blockStatus: "",
        isVip: "",
        isJoinActivity: "",
        isRepeatCrm: '',
        registerAddress: '',
        version: "",
        education: "",
        registerIpAddress: "",
        registerType: '',
        source: "",
        endRegisterTime: "",//结束注册使劲
        beginRegisterTime: "",//开始注册时间
        monthlyIncome: "",//月收入
        accountId: "",
        beginLastActiveTime: "",//开始活跃时间
        endLastActiveTime: "",//结束活跃时间
        isTestAccount: "",//是否测试号
        beginPullStringsApplyTime: "",//开始牵线时间
        endPullStringsApplyTime: "",//结束牵线时间
        isPullStrings: "",//直营牵线
        nickNameStatus: "",//昵称审核
        fffamount: "",
        headIconStatus: "",//头像审核
        sex: '',
        endAppearanceScore: "",//结束颜值分数
        beginAppearanceScore: "",//开始颜值分数
        nickName: "",
        searchType: 2,
        beginHeight: '',
        endHeight: "",
        maritalStatus: "",//婚姻状况
        phone: "",
        beginAge: "",
        endAge: "",
        current: 1,
        size: 20,
        // token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      },
      rechargeForm: {
        accountId: undefined,
        operate: undefined,
        coins: undefined,
        remark: '',
      },
      rechargeRules: {
        operate: [
          {required: true, message: '请选择充值或扣减', trigger: 'blur'}
        ],
      },
      rechargeVisible: false,
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.roleId = JSON.parse(localStorage.getItem('userlist'))
    this.ssoServer = Vue.prototype.GLOBAL.ssoServer
    let tokenId = localStorage.getItem('tokenId');
    this.adder = tokenId


    // this.getdata(this.formInline)
  },
  mounted() {
    this.formLIst()
    this.getAddress()
    this.getAddresss()
    this.ongetAddress()
    this.userifom = localStorage.getItem('userifom');


  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    onClkiher(e) {
      if (e == 2) {
        getRefundList({
          accountId: this.onaccountId,
          type: 2,
        }).then(res => {
          if (res.code == 0) {
            this.CludList = res.data.list
            this.dialogFormVisible = true
          }
        })
      }

    },
    QQFormVisible() {

      this.FormVisible = false

    },
    beforeHandleCommand(flag, command) { // flag为传递的参数
      return {
        'flag': flag,
        'command': command
      }
    },

    OnsubmitFormLg(formLg) {
      this.$refs[formLg].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });

          platformAccount({
            deviceId: this.formLg.deviceId,
            blockStatus: this.formLg.blockStatus,
            toAccountId: this.formLg.toAccountId,
            type: this.typenum
          }).then(res => {

            if (res.code == 0) {
              this.FormVisible = false
              this.$message({
                type: 'success',
                message: '拉黑成功'
              })
              this.formLg.blockStatus = ''
              this.formLIst()
            } else {
            }

          })
          setTimeout(() => {
            loading.close();
          }, 500);


        } else {

          console.log('error submit!!');
          return false;
        }
      });
    },


    async onCommand(command) {
      if (command.flag == 'a') {
        this.typenum = 1
        this.formLg.deviceId = command.command.deviceId,
          this.formLg.toAccountId = command.command.id
        if (command.command.blockStatus != 0) {

          this.$confirm('是否将该用户的状态设为取消系统拉黑?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            platformAccount({
              deviceId: this.formLg.deviceId,
              blockStatus: 0,
              toAccountId: this.formLg.toAccountId,
              type: 1
            }).then(res => {
              if (res.code == 0) {
                this.FormVisible = false
                this.$message({
                  type: 'success',
                  message: '操作成功'
                })
                this.formLg.blockStatus = ''
                this.formLIst()
              } else {
              }

            })
            // this.$message({
            //   type: 'success',
            //   message: '删除成功!'
            // });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });

        } else {
          this.FormVisible = true
        }


      } else if (command.flag == 'c') {
        this.form.accountId = command.command
        // this.accountId
        this.form.resource = 1
        this.onaccountId = command.command,
          getRefundList({
            accountId: command.command,
            type: 1,
          }).then(res => {
            if (res.code == 0) {
              this.getRefundList = res.data.list
              this.dialogFormVisible = true
            }
          })


      } else if (command.flag == 'b') {
        this.$router.push({
          path: "/goods/userGoods",
          query: { //query是个配置项
            id: command.command
          }
        })


      } else if (command.flag == 'd') {

        this.typenum = 2
        this.formLg.deviceId = command.command.deviceId,
          this.formLg.toAccountId = command.command.id

        //  console.log(command);
        if (command.command.deviceBlockStatus != 0) {

          this.$confirm('是否将该用户的状态设为取消设备拉黑?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {

            platformAccount({
              deviceId: this.formLg.deviceId,
              blockStatus: 0,
              toAccountId: this.formLg.toAccountId,
              type: 2
            }).then(res => {

              if (res.code == 0) {
                this.FormVisible = false
                this.$message({
                  type: 'success',
                  message: '操作成功'
                })
                this.formLg.blockStatus = ''
                this.formLIst()
              } else {
              }

            })
            // this.$message({
            //   type: 'success',
            //   message: '删除成功!'
            // });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });

        } else {
          this.FormVisible = true
        }


      } else if (command.flag == 'e') {
        this.rechargeForm.accountId = command.command
        let res = await walletCoins({accountId: command.command})
        this.rechargeForm.balance = res.data
        this.rechargeVisible = true;
      }

    },
    ongetAddress() {
      Axios({
        method: 'get',
        url: this.ssoServer + '/api/source-config/getList',
        headers: {
          tokenId: this.adder
        },
      }).then(res => {
        console.log(res);
        this.forlist = res.data.data
        // this.options123 = res.data.data

      })

    },


    close() {
      this.ifrefundAmount = false
      this.form.accountId = ''
      this.form.orderId = ''
      this.form.refundAmount = ''
      this.form.refundReason = ''

    },
    quxiaodialogFormVisible() {

      // this.$refs ["formInline"].resetFields()
      this.dialogFormVisible = false
      this.getRefundform = ''


      this.ifrefundAmount = false
      this.form.accountId = ''
      this.form.orderId = ''
      this.form.refundAmount = ''
      this.form.refundReason = ''
      // this.$refs ["formInline"].clearValidate()
    },
    changIput(e) {
      if (e.payType == 1) {
        this.getRefundform = '微信支付'
      } else {
        this.getRefundform = '在线支付'
      }

      // console.log(e.payType);
      if (e.amount == 0) {
        this.ifrefundAmount = false
      } else {
        this.ifrefundAmount = true
      }
      this.getamount = e.amount
      // console.log(e.amount);
    },


    OnsubmitForm(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });

          if (this.form.refundAmount > this.getamount) {
            this.$message({
              type: 'warning',
              message: '退款输入金额不可大于活动金额'
            })
            setTimeout(() => {
              loading.close();
            }, 500);
            return

          }

          Axios({
            method: 'post',

            url: this.ssoServer + '/api/orders/refund',
            headers: {
              tokenId: this.adder
            },
            data: this.form
          }).then(res => {
            if (res.data.code == 999) {
              setTimeout(() => {
                localStorage.removeItem('tokenId')

                this.$store.commit('logout', 'false')
                this.$router.push({path: '/login'})
                this.$message({
                  type: 'success',
                  message: '登录过期,请重新登录'
                })
              }, 1000)
            }
            // console.log(res);
            if (res.data.code == 0) {
              this.dialogFormVisible = false
              this.$message({
                message: '退费成功',
                type: 'success'
              });
              this.formInline.current = 1
              this.formLIst()

              this.ifrefundAmount = false
              this.form.accountId = ''
              this.form.orderId = ''
              this.form.refundAmount = ''
              this.form.refundReason = ''
            } else {
              // loading.close();
              this.$message({
                message: res.data.message,
                type: 'error'
              });
              setTimeout(() => {
                loading.close();
              }, 500);
            }
          })


          setTimeout(() => {
            loading.close();
          }, 500);


        } else {

          console.log('error submit!!');
          return false;
        }
      });
    },
    // 删除用户数据
    deledUser() {

      if (this.importList.length == 0) {
        this.$message({
          type: 'warning',
          message: '请选择要删除的数据'
        })
        return

      } else {
        this.delleVisible = true
      }


    },
    deleLVisibles() {


      Axios({
        method: 'post',

        url: this.ssoServer + '/api/platform-account/delete',
        headers: {
          tokenId: this.adder
        },
        data: {
          accountIds: this.importList
        },


      }).then(res => {
        if (res.data.code == 999) {
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({path: '/login'})
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        console.log(res);
        if (res.data.code == 0) {

          this.delleVisible = false
          this.$message({
            message: '删除成功',
            type: 'success'
          });

          this.formInline.current = 1
          this.ifShowbar = 1
          this.importList = []
          this.formLIst()
        }
      })


    },
    Clickbutton(id) {
      this.$router.push({
        path: "/goods/userGoods",
        query: { //query是个配置项
          id: id
        }
      })

    },
    Clickbuttons(id) {

      Axios({
        method: 'get',
        url: this.ssoServer + '/api/orders/getRefundList',

        headers: {
          tokenId: this.adder
        },
        params: {
          accountId: id
        }

      }).then(res => {
        // console.log(res.data.list);
        if (res.data.code == 999) {
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({path: '/login'})
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }

        this.getRefundList = res.data.data.list

      })

      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].clearValidate();
      })

    },
    getAddress() {
      Axios({
        method: 'get',
        url: this.ssoServer + '/api/common/getAddressList1',

        headers: {
          tokenId: this.adder
        },
      }).then(res => {
        if (res.data.code == 999) {
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({path: '/login'})
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        // console.log("getAddressList", res.data.data);
        this.options123 = res.data.data

      })
    },
    getAddresss() {
      Axios({
        method: 'get',
        url: this.ssoServer + '/api/common/getAddressList1',
        headers: {
          tokenId: this.adder
        },
      }).then(res => {
        if (res.data.code == 999) {
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({path: '/login'})
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        // console.log("getAddressList", res.data.data);
        this.options1234123 = res.data.data

      })
    },

    change1(e) {
      console.log("change1", e);
      if (e.length === 1) {
        this.$message({
          type: 'error',
          message: '请选择详细地址'
        })
      }
      if (e.length === 2) {
        this.formInline.registerAddress = e[1];
      }
    },
    onChange(e) {

      this.formInline.registerAddress = e[1]
      // console.log( this.formInline.registerAddress);


    },
    onChanges(e) {
      this.formInline.registerIpAddress = e[1]
      // console.log( this.formInline.registerAddress);
    },
    // checkChange(a,b){
    //   console.log(a,b);

    // },
    selectallsif() {
      this.ifShowbar = 1
      this.$refs.multipleTable.clearSelection();//清除全选
      this.importList = []


    },
    selectalls(rows) {
      this.ifShowbar = 2

      if (rows) {
        let data = []
        rows.forEach((item) => {
          data.push(item.id)
          this.importList = data
          console.log(this.importList);

        })


        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();//清除全选
      }
    },


    selectall(val) {

      let data = []
      val.forEach((item) => {
        data.push(item.id)
        this.importList = data
        // console.log(this.importList);

      })
      if (val.length == 0) {
        this.importList = ''
        // console.log('111111111');
      }

    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 导出数据

    select(selection, row) {
      console.log(selection);
      this.importList = selection


      let data = []
      // this.importList=''
      selection.forEach((item) => {
        data.push(item.id)
        this.importList = data
        // console.log(this.importList);

      })

      // if(this.importList.length>0){
      //  this.ifShowbar=2
      // }else{
      //   this.ifShowbar=1
      // }
      // console.log(this.importList.length);


    },

    imporList(index) {
      if (index == 1) {
        if (this.importList.length == 0) {
          this.$message({
            type: 'warning',
            message: '请选择要导出的数据'
          })
          return

        } else {
          this.dialogVisible = true
        }
      } else {
        if (this.importList.length == 0) {
          this.$message({
            type: 'warning',
            message: '请选择要导入的数据'
          })
          return
        }


        this.$confirm('确定要导入CRM?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          setTimeout(() => {
            Axios({
              method: 'post',

              url: this.ssoServer + '/api/platform-account/importCrm',
              headers: {
                tokenId: this.adder
              },
              data: {
                accountIds: this.importList,
                searchType: 1
              },

            }).then(res => {
              if (res.data.code == 0) {
                this.$message({
                  type: 'success',
                  message: '导入成功'
                })
                this.ifShowbar = 1
                this.dialogVisiblCrm = false

                this.formLIst()
                this.importList = []

              } else {
                this.$message({
                  type: 'warning',
                  message: res.data.message
                })
              }


            })

            loading.close();
          }, 500);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });


      }


    },
    dialogVisibles() {
      Axios({
        method: 'post',

        url: this.ssoServer + '/api/platform-account/exportExcel',
        headers: {
          tokenId: this.adder
        },
        data: {
          accountIds: this.importList,
          searchType: 2
        },
        responseType: 'blob'
      }).then(res => {
        // console.log(res.headers.);
        const link = document.createElement('a') // 创建a标签
        const blob = new Blob([res.data], {type: 'application/vnd.ms-excel;charset=UTF-8'})
        link.href = window.URL.createObjectURL(blob)
        const filename = '用户列表'
        link.download = decodeURIComponent(filename) // 如果需要自定义下载文件名，则手动设置
        link.click()
        window.URL.revokeObjectURL(link.href)
      })
      this.formInline.current = 1
      this.ifShowbar = 1
      this.importList = []
      this.formLIst()
      this.$message({
        type: 'success',
        message: '导出成功'
      })
      this.dialogVisible = false
    },
    resetForm(formInline) {
      this.$refs[formInline].resetFields();
    },
    formLIst() {
      Axios({
        method: 'get',
        url: this.ssoServer + '/api/platform-account/accountList',
        headers: {
          tokenId: this.adder
        },
        params: this.formInline
      }).then(res => {
        if (res.data.code == 999) {
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({path: '/login'})
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        } else if (res.data.code == 500) {
          this.$message({
            type: 'warning',
            message: res.data.message
          })
        }
        this.listData = res.data.data.list

        this.pageparm.currentPage = this.formInline.current
        this.pageparm.pageSize = this.formInline.size
        this.pageparm.total = res.data.data.total
        console.log(res);
      })

    },
    formatData(row, column, cellValue, index) {

      //把传过来的日期进行回炉重造一下，又创建了一个js的 Date对象，进行重新构造，转为String字符串
      //最终返回 s 就可以了
      var s = new Date(cellValue).toLocaleString();
      return s;

      // 测试参数含义：不知道参数是什么含义的就打印出来
      // console.log(row)     	//拿到一行的所有信息，要拿到具体信息,只需要row.XXX 就可以了
      // console.log(column)  	//拿到列的信息
      // console.log(cellValue) //拿到单元格数据，拿到时间 2022-03-18T01:46:08.000+00:00
      // console.log(index)     //拿到索引
    },

    // 获取公司列表

    handleSizeChange(e) {
      // reru console.log(e.pageSize);
      this.formInline.size = e.pageSize
      this.formInline.current = e.currentPage

      this.formLIst()
      // console.log(e);
    },
    // 分页插件事件
    callFather(parm) {
      console.log(parm);

      this.formInline.size = parm.pageSize
      this.formInline.current = parm.currentPage
      this.formLIst()
    },
    // 搜索事件
    search() {
      this.formInline.current = 1
      this.formLIst()


    },


    closeDialog() {
      this.editFormVisible = false
    },

    handleRecharge() {
      this.$refs.rechargeForm.validate((valid) => {
        if (valid) {
          rechargeOperate(this.rechargeForm).then(res => {
            if (res.code === 0) {
              this.$message({
                type: 'success',
                message: '操作成功'
              });
              this.rechargeVisible = false;
              this.rechargeForm = {
                accountId: undefined,
                operate: undefined,
                coins: undefined,
                remark: '',
              };
              this.formLIst();
            } else {
              this.$message({
                type: 'error',
                message: res.message
              });
            }
          }).catch(err => {
            this.$message({
              type: 'error',
              message: '操作失败，请稍后再试'
            });
          });
        }
      });
    }
  }
}

</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

/* .el-form-item{
    margin-bottom: 0px;
} */

.userRole {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/views/goods/UserList.vue